import React from 'react';

import './indent.css';

const Indent = ({ children }) => <div className="indent-level">{children}</div>;

export default Indent;
